<script setup lang="ts">
import { AppButton, AppFormHeader } from '@/components/base';
import { useAuthStore } from '@/modules/auth/store/auth';

const { user, isClient } = useAuthStore();

const props = withDefaults(
  defineProps<{
    title?: string;

    showHeader?: boolean;
    isOnboarding?: boolean;
  }>(),
  {
    title: 'Privacy Policy',

    showHeader: false,
    isOnboarding: true,
  }
);

const emits = defineEmits<{
  (e: 'next', nextPage: string): void;
}>();

const router = useRouter();
const { data, pending, execute } = useGetData();

const html = computed((): string => {
  return (data.value as string) || '';
});

const fetch = async (): Promise<void> => {
  await execute('/pages/privacy');
};

const { data: userData, error: serverError, execute: execSubmit, pending: buzy } = useSubmit();

const { getSession } = useAuth();
const next = async (): Promise<void> => {
  await execSubmit('auth/onboarding/complete', { method: 'POST' });

  await getSession();

  if (!serverError.value) {
    if (user.subscribed || isClient) {
      await navigateTo({ name: 'index' });
    } else {
      emits('next', 'membership');
    }
  }
};

const back = (): void => {
  router.back();
};

onMounted(async () => {
  await fetch();
});
</script>
<template>
  <div class="privacy-policy">
    <div class="privacy-policy__header">
      <AppTypography type="title-1" class="privacy-policy__title">{{ title }}</AppTypography>
      <AppButton variant="text" color="primary" class="privacy-policy__close-btn" @click="back()">
        <v-icon>mdi-chevron-left</v-icon>Back
      </AppButton>
    </div>
    <template v-if="!pending">
      <div v-html="html" class="mb-10" />
    </template>
    <template v-else>
      <v-skeleton-loader type="article" />
      <v-skeleton-loader type="paragraph" />
      <v-skeleton-loader type="paragraph" />
    </template>
    <!-- <template v-if="isOnboarding">
      <AppButton color="primary" block class="privacy-policy__save mt-6 mb-5" @click="next()">Continue</AppButton>
    </template>
    <template v-else>
      <AppButton color="primary" block class="privacy-policy__back mt-6 mb-5" @click="back()">Back</AppButton>
    </template> -->
  </div>
</template>
<style lang="scss" scoped>
.privacy-policy {
  width: 100%;
  max-width: 896px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-sizing: border-box;
  max-height: 80vh;
  overflow-y: auto;

  &__header {
    width: 100%;
    margin-bottom: 24px;
  }

  &__title {
    font-weight: bold;
  }

  &__close-btn {
    cursor: pointer;
    font-size: 20px;
    color: #333;
    
    &:hover {
      color: #666;
    }
  }

  .privacy-policy__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .privacy-policy__title {
    font-size: 20px;
    font-weight: bold;
  }

  @media (max-width: 600px) {
    max-width: 95vw;
    padding: 16px 8px;
    font-size: 0.95rem;
    max-height: 80vh;
  }
}
</style>
